export type PublicReviewIdentityMode = "MASKED" | "PUBLIC" | "ANONYMOUS";

type ReviewIdentityInput = {
  identityMode?: PublicReviewIdentityMode | null;
  senderName?: string | null;
};

export function getMaskedReviewName(fullName: string | null | undefined) {
  if (!fullName?.trim()) return "Sakriven identitet";

  const nameParts = fullName.trim().split(/\s+/).filter(Boolean);
  if (nameParts.length === 1) return `${nameParts[0]?.[0] ?? "K"}.`;

  const firstName = nameParts[0] ?? "";
  const lastName = nameParts[nameParts.length - 1] ?? "";

  if (!firstName || lastName.length <= 2) return "Sakriven identitet";

  const visibleStart = lastName.slice(0, 2);
  const visibleEnd = lastName.length > 5 ? lastName.slice(-2) : "";
  const stars = "*".repeat(Math.max(lastName.length - 4, 4));

  return `${firstName[0]}. ${visibleStart}${stars}${visibleEnd}`;
}

export function getPublicReviewName({
  identityMode,
  senderName,
}: ReviewIdentityInput) {
  if (identityMode === "ANONYMOUS") return "Anonimna recenzija";
  if (identityMode === "PUBLIC") return senderName?.trim() || "Klijent";

  return getMaskedReviewName(senderName);
}

export function isAnonymousReview(
  identityMode?: PublicReviewIdentityMode | null,
) {
  return identityMode === "ANONYMOUS";
}

export function shouldShowPublicReviewImage(
  identityMode?: PublicReviewIdentityMode | null,
) {
  return (
    identityMode === "PUBLIC" || !identityMode || identityMode === "MASKED"
  );
}

export function shouldBlurPublicReviewImage(
  identityMode?: PublicReviewIdentityMode | null,
) {
  return !identityMode || identityMode === "MASKED";
}
